import { useId } from 'react'

import { AstraParagraph } from '../../Typography/AstraParagraph/AstraParagraph'
import { getHelperTextId } from './AstraInputWrapper'

type Props = {
    helperText?: string
    id?: string
}

export const AstraHelperText = ({ helperText, id }: Props) => {
    const uniqueId = useId()
    const helperTextId = id ? getHelperTextId(id) : `helper-text-${uniqueId}`

    if (!helperText) return null

    return (
        <AstraParagraph id={helperTextId} variant="body-small" className="text-wrap text-muted">
            {helperText}
        </AstraParagraph>
    )
}
